import CryptoJS from 'crypto-js'
import {
	BASE_URL,
	DESCONFIG3
} from '@/config'

export const throttle = (function() {
	let timeout = null;
	return function(func, wait) {
		let context = this;
		let args = arguments;
		if (!timeout) {
			timeout = setTimeout(() => {
				timeout = null;
				func.apply(context, args)
			}, wait)
		}
	}
})();

export const debounce = (function() {
	let timer = {};
	return function(func, wait) {
		let context = this; // 注意 this 指向
		let args = arguments; // arguments中存着e
		let name = arguments[0].name || 'arrow'; //箭头函数
		if (timer[name]) clearTimeout(timer[name]);
		timer[name] = setTimeout(() => {
			func.apply(this, args)
		}, wait)
	}
})();



export function checkIdCard(idCard) {
	//15位和18位身份证号码的正则表达式
	var regIdCard =
		/^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
	//如果通过该验证，说明身份证格式正确，但准确性还需计算
	if (regIdCard.test(idCard)) {
		if (idCard.length == 18) {
			var idCardWi = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); //将前17位加权因子保存在数组里
			var idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); //这是除以11后，可能产生的11位余数、验证码，也保存成数组
			var idCardWiSum = 0; //用来保存前17位各自乖以加权因子后的总和
			for (var i = 0; i < 17; i++) {
				idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i];
			}
			var idCardMod = idCardWiSum % 11; //计算出校验码所在数组的位置
			var idCardLast = idCard.substring(17); //得到最后一位身份证号码
			//如果等于2，则说明校验码是10，身份证号码最后一位应该是X
			if (idCardMod == 2) {
				if (idCardLast == "X" || idCardLast == "x") {
					return true;
				} else {
					return false;
				}
			} else {
				//用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
				if (idCardLast == idCardY[idCardMod]) {
					return true;
				} else {
					return false;
				}
			}
		}
	} else {
		return false;
	}
}

export function checkPhone(phone){ 
    if(!(/^1[3456789]\d{9}$/.test(phone))){
        return false; 
    }
	return true;
}

export function openLocation(lat, lng, name, address) {
	openWindow( 'http://apis.map.qq.com/uri/v1/marker?marker=coord:' + lat + ',' + lng + ';title:' + name + ';addr:' + address)
}


// 打开新页面
export function openWindow (url) {
	var a = document.createElement('a');
	a.setAttribute('href', url);
	a.setAttribute('target', '_blank');
	a.setAttribute('id', 'startTelMedicine');
	// 防止反复添加
	if(document.getElementById('startTelMedicine')) {
		document.body.removeChild(document.getElementById('startTelMedicine'));
	}
	document.body.appendChild(a);
	a.click();
}

/**
 *@description 判断数据类型
 * @param {*} anything 任意数据类型 any
 * @return {string} 返回数据类型有Array,Number,Object,Boolean,String,Undefined,Function,Null
 */
export function getVariableType(anything) {
	return Object.prototype.toString.call(anything).slice(8, -1)
}

// 判断对象是否相等
export const diffByObj = (obj1, obj2) => {
	var o1 = obj1 instanceof Object;
	var o2 = obj2 instanceof Object;
	// 判断是不是对象
	if (!o1 || !o2) {
		return obj1 === obj2;
	}

	//Object.keys() 返回一个由对象的自身可枚举属性(key值)组成的数组,
	//例如：数组返回下表：let arr = ["a", "b", "c"];console.log(Object.keys(arr))->0,1,2;
	if (Object.keys(obj1).length !== Object.keys(obj2).length) {
		return false;
	}
	var isDif = true;
	for (var o in obj1) {
		var t1 = obj1[o] instanceof Object;
		var t2 = obj2[o] instanceof Object;
		if (t1 && t2) {
			isDif = diffByObj(obj1[o], obj2[o]);
		} else if (obj1[o] !== obj2[o]) {
			isDif = false;
			break;
		}
	}
	return isDif;
}

// 深拷贝
export const deepClone = obj => {
	if (typeof obj !== 'object') return
	const newObj = obj instanceof Array ? [] : {}
	for (const key in obj) {
		if (obj.hasOwnProperty(key)) {
			newObj[key] = getVariableType(obj[key]) === 'Object' ? deepClone(obj[key]) : obj[key]
		}
	}
	return newObj
}

// 3DES加密
export function desEncrypt(str, key = DESCONFIG3.key, iv = DESCONFIG3.iv) {
	if (typeof(str) == 'object'){
		str = CryptoJS.enc.Utf8.parse(str);
	}
	var cryptoKey = CryptoJS.enc.Utf8.parse(key)
	var cryptoIv = CryptoJS.enc.Utf8.parse(iv.substr(0, 8))
	var encodeStr = CryptoJS.TripleDES.encrypt(str, cryptoKey, {
		iv: cryptoIv,
		mode: CryptoJS.mode.CBC,
		padding: CryptoJS.pad.Pkcs7
	})
	return encodeStr.toString();
}

export const localCatch = {
	set(key, val) {
		let type = getVariableType(val).toLowerCase();
		window.localStorage.setItem(key, JSON.stringify({
			type: type,
			data: val
		}));
	},
	get(key) {
		let data = JSON.parse(window.localStorage.getItem(key) || '{}');
		return data.data;
	},
	remove(key) {
		window.localStorage.removeItem(key)
	},
	clear() {
		window.localStorage.clear();
	}
}


export const sessionCatch = {
	set(key, val) {
		let type = getVariableType(val).toLowerCase();
		window.sessionStorage.setItem(key, JSON.stringify({
			type: type,
			data: val
		}));
	},
	get(key) {
		let data = JSON.parse(window.sessionStorage.getItem(key) || '{}');
		return data.data;
	},
	remove(key) {
		window.sessionStorage.removeItem(key)
	},
	clear() {
		window.sessionStorage.clear();
	}
}